import { render } from "./TLabel.vue?vue&type=template&id=02792bf8"
import script from "./TLabel.vue?vue&type=script&lang=js"
export * from "./TLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__